module.exports = __webpack_public_path__ + "static/img/img-home-jzg-03.a54ec2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-03.png
// module id = ERAS
// module chunks = 1